import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4636" />
      <ArchitectureDiagram data-id="element-4637" />
      <HowItWorksConnections mode="how" data-id="element-4638" />
      <LivesInSlack data-id="element-4639" />
      <ComputerUse data-id="element-4640" />
      <CapabilityGrid data-id="element-4641" />
      <NarrativeSection data-id="element-4642" />
      <ToolComparison data-id="element-4643" />
      <WallOfLove data-id="element-4644" />
      <PricingSection data-id="element-4645" />
      <ClosingCTA data-id="element-4646" />
    </>;
}